/**
 * Created by eliasmj on 21/09/2015.
 */
/**
 * Created by eliasmj on 10/09/2015.
 */
angular.module('qkr.mssConfig')
    .config(($routeSegmentProvider, appUrl) => {
        $routeSegmentProvider.options.autoLoadTemplates = true;

        $routeSegmentProvider.
            when('/mssconfig/settings', 'settings', { pageTitle: 'Config List' }).
            when('/mssconfig/hottranslations', 'hotTranslation').
            when('/mssconfig/reports', 'reports').
            when('/mssconfig/messages/details', 'translations');

        $routeSegmentProvider
            .segment('settings', {template: require('../../mssConfig/templates/settings.html')})
            .segment('hotTranslation', {template: require('../../mssConfig/templates/upload.hot.translation.html')})
            .segment('reports', {template: require('../../mssConfig/templates/reports.html')})
            .segment('translations', {template: require('../../mssConfig/templates/messages.html')});
});




// WEBPACK FOOTER //
// ./src/mssConfig/config/mss.config.js